import { IMenuItem } from '.';
import { mainMenuTypes } from './menu.enum';

export const mainMenuTop: IMenuItem[] = [
    {
        id: mainMenuTypes.Launchpad,
        name: 'LAUNCHPAD_TITLE',
        matchedLabel: 'LAUNCHPAD_TITLE',
        component: 'LaunchPadPage',
        icon: 'launch-pad',
        requiresPermission: false,
        linkChunk: 'apps',
        link: '/apps'
    },
    {
        id: mainMenuTypes.PasswordVaults,
        name: 'MY_PASSWORDS',
        matchedLabel: 'PASSWORD_VAULTS',
        component: 'PasswordVaultsPage',
        requiresPermission: true,
        icon: 'my-passwords',
        linkChunk: 'passwords',
        link: '/passwords'
    }
];
